import React from 'react'
// libs
import { publicClient } from 'lib/apollo-client'
import { ApolloProvider } from '@apollo/client/react'
// component
import Grid from '@mui/material/Grid2'
// views
import { ContentWrapper, LeftPart, RightPart, Title, Layout } from './views'
// themes
import { AuthPaper, Logo } from 'themes/views/auth'

type Props = React.PropsWithChildren<unknown>

const styles = {
  formWrapper: {
    flexGrow: 3,
    marginBottom: 30
  },
  logoWrapper: {
    flexGrow: 2
  }
}

const AuthLayout: React.FC<Props> = ({ children }) => (
  <ApolloProvider client={publicClient}>
    <Layout>
      <LeftPart>
        <ContentWrapper>
          <Title variant='h5' gutterBottom>
            Ignite your strategy today with skefto SPARC
          </Title>
        </ContentWrapper>
      </LeftPart>
      <RightPart>
        <AuthPaper square>
          <Grid container direction='column' justifyContent='space-between'>
            <Grid container direction='column' justifyContent='center' style={styles.formWrapper} wrap='nowrap'>
              {children}
            </Grid>
            <Grid alignItems='center' justifyContent='center' style={styles.logoWrapper}>
              <Logo />
            </Grid>
          </Grid>
        </AuthPaper>
      </RightPart>
    </Layout>
  </ApolloProvider>
)

export default AuthLayout
